import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import findEmailAddress from '../utils/findEmailAddress';
import { mutator } from 'satcheljs';
import {
    updateHasDLRecipient,
    addRecipientsIntoLink,
    updateRecipientPermissionInfo,
    removeRecipientsFromLink,
} from '../actions/publicActions';

mutator(updateHasDLRecipient, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLinkInfo.sharingInfo.hasDLRecipient = actionMessage.hasDLRecipient;
});

mutator(addRecipientsIntoLink, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    actionMessage.recipients.forEach(recipient => {
        if (
            !findEmailAddress(
                recipient.emailAddress,
                sharingLinkInfo.sharingInfo.recipientPermissionInfos
            )
        ) {
            sharingLinkInfo.sharingInfo.recipientPermissionInfos.push(recipient);
        }
    });
});

mutator(updateRecipientPermissionInfo, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLinkInfo.sharingInfo.recipientPermissionInfos.forEach(permissionInfo => {
        if (permissionInfo.emailAddress === actionMessage.emailAddress) {
            permissionInfo.hasAccess = actionMessage.hasAccess;
            permissionInfo.canHaveAccess = actionMessage.canHaveAccess;
            permissionInfo.getPermissionInfoStatus = actionMessage.getPermissionInfoStatus;
        }
    });
});

mutator(removeRecipientsFromLink, actionMessage => {
    const sharingLinkInfo: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLinkInfo.sharingInfo.recipientPermissionInfos = sharingLinkInfo.sharingInfo.recipientPermissionInfos.filter(
        function(recipientPermissionInfo) {
            return !findEmailAddress(
                recipientPermissionInfo.emailAddress,
                actionMessage.recipients
            );
        }
    );
});
